<template>
  <common-modal
    :name="name"
    :title="title"
    :primaryAction="importModalPrimaryAction"
    :onClosed="onModalClosed"
    :disabledActions="importDisabledActions"
    height="auto"
    width="60%"
  >
    <template #modal-body>
      <slot name="template-desc"></slot>

      <vue-dropzone
        ref="filesZone"
        id="csvImportZone"
        :options="dropzoneOptions"
        :useCustomSlot="true"
        @vdropzone-file-added="addedFile"
        v-show="!file"
      >
        <div class="isis-dropzone-content">
          <h3 class="dropzone-custom-title">
            <i class="fas fa-upload"></i>
          </h3>
          <h4 class="title">{{ $t("smi_sri.add_file") }}</h4>
          <div class="subtitle">
            ...{{ $t("smi_sri.or_drop_file_to_upload") }}
          </div>
        </div>
      </vue-dropzone>

      <div class="isis-file-preview" v-if="file">
        <div class="file-infos-row">
          <div class="file-infos">
            <div class="logo"><i class="fas fa-file-csv"></i></div>
            <p>{{ file.name }}</p>
          </div>
          <md-button @click="onReplaceFile" class="replace-file-btn">
            {{ $t("smi_sri.replace_file") }}
          </md-button>
        </div>
        <xlsx-preview
          :sheets="sheets"
          @invalid-sheets="invalidFile = $event"
        ></xlsx-preview>
      </div>
    </template>
  </common-modal>
</template>

<script>
import CommonModal from "@/components/Base/CommonModal";
import { NotificationStore } from "@/components/NotificationPlugin";
import vue2Dropzone from "vue2-dropzone";
import { getSheetsObjectFrom, readXlsxFile } from "@/libs/Xlsx/index.js";
import XlsxPreview from "./XlsxPreview.vue";

const initialFileData = () => ({});

export default {
  components: { CommonModal, vueDropzone: vue2Dropzone, XlsxPreview },
  props: [...CommonModal.props, "actions", "formatImportedData"],
  data() {
    return {
      file: null, // to keep added file,
      invalidFile: true,
      sheets: initialFileData(),
      dropzoneOptions: {
        url: "https://examle.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        acceptedFiles: ".xlsx",
        maxFiles: 1,
        autoProcessQueue: false, // not-allow auto send file. Ref: https://www.dropzonejs.com/#config-autoProcessQueue
        previewTemplate: this.genPreviewTemplate()
      }
    };
  },
  computed: {
    importDisabledActions: function() {
      return !this.file || (this.file && this.invalidFile);
    },

    importModalPrimaryAction() {
      const propsPrimaryAction = this.actions.primary;

      return {
        ...propsPrimaryAction,
        action: () => {
          this.actions.primary.action && this.actions.primary.action(this.file);
        }
      };
    }
  },
  methods: {
    genPreviewTemplate: function() {
      return `<div class="dz-preview dz-file-preview"></div>`;
    },

    addedFile(file) {
      // remove old file from dropzone
      this.file && this.$refs.filesZone.removeFile(this.file);

      setTimeout(() => {
        if (file.status === "error") {
          this.handleUploadedFileError(file);
          return;
        }

        this.resetInvalidFileStatus();
        this.setNewFileData(file);
      }, 1);
    },

    handleUploadedFileError(file) {
      const message = !file.accepted
        ? this.$t("smi_sri.not_accepted_your_file")
        : this.$t("smi_sri.something_went_wrong");

      NotificationStore.notify({
        message,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "danger"
      });

      this.$refs.filesZone.removeFile(file);
    },

    onReplaceFile() {
      this.$refs.filesZone.$refs.dropzoneElement.click();
    },

    async setNewFileData(file) {
      try {
        this.file = file;
        await this.setSheetData(file);
      } catch (error) {
        console.log("error set file: ", error);
      }
    },

    async setSheetData(file) {
      try {
        const wbs = await readXlsxFile(file);
        this.sheets = getSheetsObjectFrom(wbs);

        if (this.formatImportedData) {
          for (const index in this.sheets) {
            this.sheets[index].data = this.formatImportedData(
              this.sheets[index].data
            );
          }
        }
      } catch (error) {
        throw error;
      }
    },

    resetInvalidFileStatus() {
      this.invalidFile = true;
    },

    onModalClosed() {
      if (this.file) {
        this.file = null;
        this.jsonFileData = initialFileData();
      }
    }
  }
};
</script>

<style lang="scss">
// .isis-modal {
//   height: fit-content !important;
// }

.isis-file-preview {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .file-infos-row {
    display: flex;
    margin-bottom: 15px;
    .file-infos {
      display: flex;
      align-items: center;

      & > * {
        display: inline-block;
        font-size: 1rem;
      }
      .logo {
        margin-right: 10px;

        i {
          font-size: 1.25rem;
        }
      }
    }
  }

  // .table-content {
  //   max-height: 46vh;
  // }

  .replace-file-btn {
    margin-left: auto;
  }
}

#csvImportZone {
  margin-top: 15px;

  padding: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #f6f6f7;
  color: #5c5f62;

  border-style: dashed;
  border-width: 2px;
  border-color: #8c9196;
  border-radius: 4px;

  font-size: 14px;
  text-align: center;
  cursor: pointer;

  &.dz-started {
    .dz-message {
      display: block !important;
    }
  }

  .isis-dropzone-content {
    display: flex;
    flex-direction: column;

    & > * {
      margin: 0px;
    }

    & > * ~ * {
      margin-top: 8px;
    }
  }

  .dz-preview {
    display: none !important;
  }
}
</style>
